import api from 'api';

export const loadTable = api('POST /api/audit-logs/grid');

export const exportTable = api('POST /api/audit-logs/export', {
  responseType: 'blob',
});
